@include host-component-properties;

:host {
  --paf-notification-block: 32;
  --paf-notification-inline-xxl: 101;
  --paf-notification-inline-large: 81;
  --paf-notification-inline-medium: 61;
  --paf-notification-inline-small: 16;
  --paf-notification-icon-color: var(--paf-global-post-brand-black);
  --paf-notification-icon-size: 48;
  --paf-notification-icon-margin-inline: 16;
  --paf-notification-font-size: 16;
  --paf-notification-line-height: 24;
  --paf-notification-background-color: var(--paf-global-post-info);
  --paf-notification-sections-margin-block: 24;
  --paf-notification-title-margin-bottom: 4;
  --paf-notification-title-font-size: 18;
  --paf-notification-link-transition-duration: 120ms;
  --paf-notification-link-hover-color: var(--paf-global-post-brand-dark);
}

.notification {
  background-color: var(--paf-notification-background-color);
  padding-block: px-to-rem(var(--paf-notification-block));
  padding-inline: px-to-rem(var(--paf-notification-inline-small));
  display: flex;
  flex-wrap: nowrap;
  column-gap: px-to-rem(var(--paf-notification-icon-margin-inline));
  color: var(--paf-notification-icon-color);

  @include mq($from: small) {
    padding-inline: px-to-rem(var(--paf-notification-inline-medium));
  }

  @include mq($from: medium) {
    padding-inline: px-to-rem(var(--paf-notification-inline-large));
  }

  @include mq($from: wide) {
    padding-inline: px-to-rem(var(--paf-notification-inline-xxl));
  }

  .title {
    font-size: px-to-rem(var(--paf-notification-title-font-size));
    font-weight: var(--paf-global-font-weight-bold);
    margin-inline: 0;
    margin-block: 0 px-to-rem(var(--paf-notification-title-margin-bottom));
  }

  .icon {
    flex-basis: px-to-rem(var(--paf-notification-icon-size));
    flex-shrink: 0;
    flex-grow: 0;
    height: px-to-rem(var(--paf-notification-icon-size));
    fill: var(--paf-notification-icon-color);

    @include forced-colors {
      fill: currentcolor;
    }
  }

  .content {
    * {
      font-size: px-to-rem(var(--paf-notification-font-size));
      line-height: px-to-rem(var(--paf-notification-line-height));
      margin: 0 0 px-to-rem(var(--paf-notification-sections-margin-block));
      color: var(--paf-notification-icon-color);
    }

    *:last-child {
      margin-block-end: 0;
    }

    a {
      word-break: break-word;
      transition: color var(--paf-notification-link-transition-duration) ease-in;

      @include hover-style {
        color: var(--paf-notification-link-hover-color);
      }
    }
  }
}
